(() => {
  if (window.__csStage1SelectionBound) return;
  window.__csStage1SelectionBound = true;

  const readTuples = (picker) => {
    try {
      const tuples = JSON.parse(picker.querySelector('[data-cs-stage1-tuples]').textContent);
      return Array.isArray(tuples) ? tuples : [];
    } catch { return []; }
  };
  const axes = (picker) => Array.from(picker.querySelectorAll('select[data-cs-stage1-axis]'));
  const setTuple = (picker, tuple) => {
    const selects = axes(picker);
    const choices = selects.map((select, index) => Array.from(select.options).find((option) => option.value === tuple.options[index]));
    if (tuple.options.length !== selects.length || choices.some((option) => !option?.dataset.optionValueId)) return false;
    selects.forEach((select, index) => {
      select.value = choices[index].value;
      Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
      choices[index].setAttribute('selected', 'selected');
    });
    return true;
  };


  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-cs-stage1-thumb]');
    const picker = button?.closest('variant-selects[data-cs-stage1-picker]');
    if (!picker || button.disabled) return;
    const tuple = readTuples(picker).find((entry) => entry.id === button.dataset.variantId);
    if (!tuple || !setTuple(picker, tuple)) return;
    axes(picker).at(-1).dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Capture runs before native variant-selects reads the option value IDs.
  document.addEventListener('change', (event) => {
    const changed = event.target;
    if (!changed.matches?.('select[data-cs-stage1-axis]')) return;
    const picker = changed.closest('variant-selects[data-cs-stage1-picker]');
    if (!picker) return;
    const selects = axes(picker);
    const axis = selects.indexOf(changed);
    const selected = selects.map((select) => select.value);
    const candidates = readTuples(picker).filter((tuple) => tuple.options.length === selects.length && tuple.options.slice(0, axis + 1).every((value, index) => value === selected[index]));
    // Preserve suffix choices when possible, otherwise choose a real approved tuple.
    const tuple = candidates.find((entry) => entry.options.every((value, index) => value === selected[index])) || candidates[0];
    if (!tuple || !setTuple(picker, tuple)) {
      event.stopImmediatePropagation();
      const current = readTuples(picker).find((entry) => entry.id === picker.dataset.csStage1CurrentVariantId);
      if (current) setTuple(picker, current);
      return;
    }
  }, true);
})();

/* Keep native sticky axes on a complete selection-card tuple before native commerce runs. */
(() => {
  if (window.__csSelectionStickyTupleBound) return;
  window.__csSelectionStickyTupleBound = true;
  document.addEventListener('change', (event) => {
    const changed = event.target;
    if (!(changed instanceof HTMLSelectElement)) return;
    const sticky = changed.closest('variant-selects[data-sticky]');
    const primary = sticky?.closest('product-info')?.querySelector('variant-selects[data-primary]');
    if (!primary || (!primary.hasAttribute('data-cs-v2-picker') && !primary.hasAttribute('data-cs-stage1-picker'))) return;
    const selects = Array.from(sticky.querySelectorAll('select'));
    const axis = selects.indexOf(changed);
    if (axis < 0) return;
    const selected = selects.map((select) => select.value);
    let tuples = [];
    if (primary.hasAttribute('data-cs-stage1-picker')) {
      try {
        const data = JSON.parse(primary.querySelector('[data-cs-stage1-tuples]').textContent);
        if (Array.isArray(data)) tuples = data.map((entry) => entry.options);
      } catch (_) {}
    } else {
      tuples = Array.from(primary.querySelectorAll('[data-cs-v2-card-radio]')).flatMap((radio) => {
        try { return [JSON.parse(radio.dataset.csV2OptionValues || 'null')]; }
        catch (_) { return []; }
      });
    }
    tuples = tuples.filter((values) => Array.isArray(values) && values.length === selects.length);
    const validChoices = (tuple) => tuple.map((value, index) =>
      Array.from(selects[index].options).find((option) => option.value === value && option.dataset.optionValueId));
    const candidates = tuples.filter((tuple) => tuple.slice(0, axis + 1).every((value, index) => value === selected[index]) && validChoices(tuple).every(Boolean));
    const tuple = candidates.find((values) => values.every((value, index) => value === selected[index])) || candidates[0];
    if (!tuple) {
      event.stopImmediatePropagation();
      try {
        const current = JSON.parse(primary.querySelector('[data-selected-variant]').textContent);
        const choices = validChoices(current.options);
        if (current.options.length === selects.length && choices.every(Boolean)) {
          selects.forEach((select, index) => {
            select.value = choices[index].value;
            Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
            choices[index].setAttribute('selected', 'selected');
          });
        }
      } catch (_) {}
      return;
    }
    const choices = validChoices(tuple);
    selects.forEach((select, index) => {
      select.value = choices[index].value;
      Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
      choices[index].setAttribute('selected', 'selected');
    });
  }, true);
})();
